import groupBy from 'lodash/groupBy'

const createLookupTable = (records) =>
  (records || []).reduce(
    (acc, record) => ({
      ...acc,
      [record.id]: record
    }),
    {}
  )

export const createLookup = (records, name) => {
  const lookup = createLookupTable(records)
  return (id, { allowMissing = false } = {}) => {
    if (!(allowMissing || Object.hasOwn(lookup, id))) {
      throw new Error(`No '${id}' key in ${name} lookup`)
    }
    return lookup[id]
  }
}

export const createGroupedLookup = (records, groupByField) => {
  const lookup = groupBy(records, groupByField)
  return (id) => lookup[id] || []
}
